export const BATTERY_UI_MAP = {
  normal: {
    label: "Normal",
    className: "battery-normal",
    dot: "green",
  },
  service_soon: {
    label: "Needs Service",
    className: "battery-service",
    dot: "orange",
  },
  replace: {
    label: "Needs Replacement",
    className: "battery-replace",
    dot: "red",
  },
  replaceordisconnected: {
    label: "Needs Replacement/Battery Disconnected",
    className: "battery-replace",
    dot: "red",
  },
  unknown: {
    label: "—",
    className: "battery-ambiguous",
    dot: "gray",
  },
  no_data: {
    label: "Ambiguous",
    className: "battery-ambiguous",
    dot: "gray",
  },
};
